import { render } from "./IconSearchDelete.vue?vue&type=template&id=b4501abc"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSearchDelete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b4501abc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b4501abc', __exports__)) {
    api.reload('b4501abc', __exports__)
  }
  
  module.hot.accept("./IconSearchDelete.vue?vue&type=template&id=b4501abc", () => {
    api.rerender('b4501abc', render)
  })

}


export default __exports__